// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"j1-z","dimensionLabel":"k1-z","styleChooserControlWrapper":"l1-z","styleChooserControl":"m1-z","disabled":"n1-z","giftCard":"o1-z","styleChooserText":"p1-z"};